import { jsx as o, jsxs as b, Fragment as h } from "react/jsx-runtime";
import { useBreadCrumbs as f } from "@made-people/grease-bread-crumbs";
import { breadcrumbsBlueprint as k } from "./index-blueprint.es.js";
import { z as r } from "zod";
import { withManagedProps as L } from "@made-people/managed-props";
import { withZod as g } from "@made-people/react-prop-guard";
import v from "clsx";
import N from "react";
import { componentWrapperSchema as W, ComponentWrapper as y } from "@made-people/blueprint-component-wrapper";
import { linkAsLinkSchema as B, LinkAsLink as j } from "@made-people/blueprint-link";
import "@made-people/blueprint";
const S = r.object({
  /**
   * Custom styling variants for the breadcrumbs component
   * Allows customization of the component's appearance through the blueprint system
   */
  variants: r.custom().optional(),
  /**
   * Layout configuration for the component wrapper
   * Controls the positioning and spacing of the breadcrumbs
   */
  layout: W.shape.layout.optional(),
  /**
   * Custom divider element between breadcrumb items
   * Defaults to "/" if not provided
   */
  divider: r.custom().optional(),
  /**
   * Additional CSS classes to apply to the breadcrumbs container
   */
  className: r.string().optional(),
  /**
   * Configuration for the link elements within breadcrumbs
   * Allows customization of link behavior and appearance
   */
  links: B.optional(),
  /**
   * Controls whether the component should be wrapped in a ComponentWrapper
   * Defaults to true
   */
  enableWrapper: r.boolean().optional(),
  /**
   * When true, renders the last breadcrumb as a non-clickable span
   * Defaults to false
   */
  disableLastLink: r.boolean().optional()
}), E = L(
  "Breadcrumbs",
  g(
    {
      schema: S,
      defaultProps: {
        divider: "/",
        enableWrapper: !0,
        disableLastLink: !1
      }
    },
    ({
      variants: m,
      layout: l,
      links: n,
      divider: p,
      className: c,
      enableWrapper: t,
      disableLastLink: d
    }) => {
      const i = f(), a = k.styles(m);
      return /* @__PURE__ */ o(
        t ? y : "div",
        {
          layout: t ? { ...l } : void 0,
          className: v(a.base, c),
          children: i.map((e, s) => {
            const u = s === i.length - 1;
            return /* @__PURE__ */ b(N.Fragment, { children: [
              s !== 0 && /* @__PURE__ */ o("span", { className: a.divider, children: p }),
              u && d ? /* @__PURE__ */ o("span", { className: a.crumb, children: e.label }) : /* @__PURE__ */ o(h, { children: /* @__PURE__ */ o(
                j,
                {
                  link: { href: e.slug },
                  className: a.crumb,
                  label: e.label,
                  ...n
                }
              ) })
            ] }, s);
          })
        }
      );
    }
  )
);
export {
  E as Breadcrumbs,
  S as breadcrumbsSchema
};
//# sourceMappingURL=index.es.js.map
